import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
  name: "app",
  initialState: {
    ministry: [],
    organizations: [],
    salutations: [],
  },
  reducers: {
    addMinistry: (state, action) => {
      state.ministry = action.payload;
    },
    addOrganizations: (state, action) => {
      state.organizations = action.payload;
    },
    addSalutations: (state, action) => {
      state.salutations = action.payload;
    },
  },
});

export const { addMinistry, addOrganizations, addSalutations } = appSlice.actions;
export default appSlice.reducer;
